import React, { useState, useEffect } from "react";
import {
  AppModal,
  AppRemixIcon,
  AppSingleSelect,
} from "@/layout/AppComponents";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import colors from "../../../../constants/colors";
import AppLink from "../../../../routing/helpers/AppLink";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../../components/helpers/Translator";

export default function CAPaginator(props) {
  const {
    page,
    pagination,
    elementPages,
    itemsPerPage,
    route,
    params,
    ...others
  } = props;
  const auth = useSelector((state) => state.auth);
  const [showPageElementsModal, setShowPageElementsModal] = useState(false);
  const [changeElementsOptions, setChangeElementsOptions] = useState([
    { label: 20, value: 20 },
    { label: 100, value: 100 },
  ]);

  useEffect(() => {
    if (
      changeElementsOptions !== undefined &&
      changeElementsOptions.filter((e) => e.value === auth.user?.pagination)
        .length === 0
    ) {
      setChangeElementsOptions([
        ...[{ label: auth.user.pagination, value: auth.user.pagination }],
        ...changeElementsOptions,
      ]);
    }
  }, []);

  const handleChangeElements = async (values) => {
    try {
      await axios.post(axiosPath("api_r_user_global_changePagination"), values);
      window.location.reload(false);
    } catch (err) {}
  };

  return (
    <nav {...others}>
      <ul
        className="pagination"
        style={{
          justifyContent: "center",
          marginBottom: "4px",
        }}
      >
        <li
          className="page-item"
          title={ReactDOMServer.renderToString(
            <Translator file="module-correctiveActions" name="go.to.page.1" />
          )}
        >
          <AppLink
            path={route}
            params={{
              ...params,
              page: 1,
            }}
            className="page-link"
          >
            <span>&laquo;</span>
          </AppLink>
        </li>
        {page > 4 && (
          <li className="page-item">
            <span className="page-link">...</span>
          </li>
        )}
        {elementPages.map(
          (p, i) =>
            page <= i + 4 &&
            page >= i - 2 && (
              <li
                key={i}
                className={`page-item${page == i + 1 ? " active" : ""}`}
              >
                <AppLink
                  path={route}
                  params={{
                    ...params,
                    page: i + 1,
                  }}
                  className="page-link"
                >
                  {i + 1}
                </AppLink>
              </li>
            )
        )}
        {page < elementPages.length - 3 && (
          <li className="page-item">
            <span className="page-link">...</span>
          </li>
        )}
        <li
          className="page-item"
          title={ReactDOMServer.renderToString(
            <Translator
              file="module-correctiveActions"
              name="go.to.page"
              variables={{ page: elementPages.length }}
            />
          )}
        >
          <AppLink
            path={route}
            params={{
              ...params,
              page: elementPages.length,
            }}
            className="page-link"
          >
            <span>&raquo;</span>
          </AppLink>
        </li>
      </ul>

      <p
        style={{
          fontSize: "10px",
          textAlign: "center",
          marginBottom: "20px",
          color: colors.grey500,
        }}
      >
        <Translator
          file="module-legalCompliance"
          name="show.results.pages"
          variables={{
            from: (page - 1) * pagination.numItemsPerPage + 1,
            to:
              (page - 1) * pagination.numItemsPerPage +
              elementPages[page - 1].length,
            total: pagination.totalCount,
            pages: elementPages.length,
          }}
          isHtml
        />
        <span
          className="text-info ml-2 pointer"
          onClick={() => setShowPageElementsModal(true)}
        >
          <Translator
            file="module-legalCompliance"
            name="change.elements.per.page"
          />{" "}
          ({auth.user.pagination})
        </span>
      </p>
      <AppModal
        show={showPageElementsModal}
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-legalCompliance"
            name="number.elements.per.page"
          />
        )}
        onClose={() => setShowPageElementsModal(false)}
      >
        <Formik
          initialValues={{
            elements: auth.user.pagination,
          }}
          onSubmit={handleChangeElements}
        >
          {({ setFieldValue, handleSubmit, values }) => (
            <AppSingleSelect
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="elements.per.page"
                />
              )}
              placeholder={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="choose.number.elements.per.page"
                />
              )}
              icon={<AppRemixIcon icon="list-ordered" noVariants />}
              options={changeElementsOptions}
              value={values.elements}
              onChange={(v) => {
                setFieldValue("elements", v);
                handleSubmit(values);
              }}
            />
          )}
        </Formik>
      </AppModal>
    </nav>
  );
}
